export function isMostlyArabic(str) {
  // Count Arabic characters
  const arabicMatches = str.match(/[\u0600-\u06FF]/g) || [];
  // If more than half the characters are Arabic, consider it Arabic
  return arabicMatches.length > str.length / 2;
}
